import { useQueryClient } from "@tanstack/react-query";
import { createContext, type ReactNode, useEffect, useMemo } from "react";

import {
  createRefreshScheduler,
  type RefreshScheduler,
} from "./_libs/refresh-scheduler";

export const RealtimeRefreshContext = createContext<RefreshScheduler | null>(
  null,
);

/**
 * Owns the app's one realtime refresh queue. Mounted once at the router root,
 * inside the QueryClient and the relay provider; every realtime provider below
 * feeds it, so one query refetches once per burst however many providers heard it.
 */
export function RealtimeRefreshRoot({ children }: { children: ReactNode }) {
  const queryClient = useQueryClient();
  const scheduler = useMemo(
    () => createRefreshScheduler(queryClient, () => Date.now()),
    [queryClient],
  );
  useEffect(() => () => scheduler.dispose(), [scheduler]);
  return (
    <RealtimeRefreshContext.Provider value={scheduler}>
      {children}
    </RealtimeRefreshContext.Provider>
  );
}
